import CampaignService from "@/service/campaign.service";

export const state = {
	campaigns: [],
	campaign: null,
}

export const mutations = {
	setCampaign(state, campaign) {
		state.campaign = campaign
	},

	setCampaigns(state, campaigns) {
		state.campaigns = campaigns
	},

}

export const actions = {
	async loadCampaigns({commit}) {
		await CampaignService.loadCampaigns().then(async campaigns => {
			commit('setCampaigns', campaigns)
		})
	},
}


export default {
	state,
	actions,
	mutations,
};